import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Tooltip,
  Avatar,
  useMediaQuery,
} from '@mui/material';
import { theme } from 'theme/theme';
import { NavLink, useLocation } from 'react-router-dom';
import { menuAdminCrear, menuAdminListados, menuAdminSitio, menuUsuario } from 'utils/constants';
import { IMenuItem } from 'utils/models/interfaces';
import './MenuDrawer.scss';
import { UsuarioDTO } from '../../../utils/models/types';

const MenuSection = ({
  titulo,
  items,
  basePath,
  open,
}: {
  titulo: string;
  items: any;
  basePath: string;
  open: boolean;
}) => {
  const location = useLocation();

  const handleClick = (path: string) => {
    const newPath = `${basePath}/${path}`;
    if (location.pathname === newPath) {
      window.location.reload();
    }
  };

  return (
    <>
      <List>
        <Tooltip
          children={
            open ? (
              <Typography
                variant="h1"
                fontSize={20}
                margin={open ? '15px 70px' : '10px 20px'}
                textAlign="left"
                color={theme.palette.primary.main}
              >
                {titulo}
              </Typography>
            ) : (
              <Avatar
                sx={{
                  bgcolor: 'white',
                  ml: 1,
                  my: 1,
                  color: 'grey',
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              >
                {titulo.slice(0, 1)}
              </Avatar>
            )
          }
          title={titulo}
          placement="right"
        />

        {items.map(({ text, path, icon: Icon }: IMenuItem) => (
          <NavLink
            to={`${basePath}/${path}`}
            key={text}
            className={({ isActive }) => (isActive ? 'activeListItem' : '')}
          >
            <ListItem disablePadding sx={{ color: theme.palette.secondary.dark }}>
              <ListItemButton onClick={() => handleClick(path)}>
                <Tooltip
                  children={<ListItemIcon>{Icon && <Icon sx={{ color: theme.palette.primary.main }} />}</ListItemIcon>}
                  title={text}
                  placement="right"
                />

                <ListItemText primary={text} className="menu-item" sx={{ display: open ? 'block' : 'none' }} />
              </ListItemButton>
            </ListItem>
          </NavLink>
        ))}
      </List>
      <Divider />
    </>
  );
};

const MenuDrawer = ({ drawerWidth, open }: { drawerWidth: number; open: boolean }) => {
  const versionMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const abierto = versionMobile ? false : open;
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: UsuarioDTO = usuarioJSON && JSON.parse(usuarioJSON);

  const esAdmin = usuario?.Rol === 'Administrador';
  const esAlumno = usuario?.EsAlumno;
  const menuUsuarioNoAlumno = !esAlumno && menuUsuario.filter(items => items.path !== 'mistalleres');

  return (
    <Drawer
      variant="permanent"
      sx={{
        [`& .MuiDrawer-paper`]: {
          width: abierto ? drawerWidth : 60,
          transition: 'width 0.3s',
          boxSizing: 'border-box',
        },
        zIndex: '-1',
      }}
      className="menuDrawer"
    >
      <Box
        sx={{
          overflow: 'auto',
          paddingTop: '140px',
          backgroundColor: theme.palette.primary.contrastText,
          height: '100%',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {/* Sección de menús */}
        <Box>
          {esAdmin && menuAdminListados && (
            <MenuSection titulo="Listados" items={menuAdminListados} basePath="/admin" open={abierto} />
          )}
          {esAdmin && <MenuSection titulo="Registros" items={menuAdminCrear} basePath="/admin" open={abierto} />}
          {esAdmin && <MenuSection titulo="Gestión" items={menuAdminSitio} basePath="/admin" open={abierto} />}
          <MenuSection
            titulo="Mi cuenta"
            items={esAlumno ? menuUsuario : menuUsuarioNoAlumno}
            basePath="/usuario"
            open={abierto}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default MenuDrawer;
